'use strict';

const { isEmpty, get, isArray, isObject, isNumber, isString, isBoolean } = require('lodash');

const $cache = {
    body: $('body'),
};

const isEmptyDatalayer = (datalayer) => {
    if (isArray(datalayer) && isEmpty(datalayer)) return true;

    return datalayer.every((item) => {
        if (isObject(item) && isEmpty(item)) {
            return true;
        }

        if (!item && item !== 0 && item !== '') {
            return true;
        }

        if (isNumber(item) || isString(item) || isBoolean(item)) {
            return true;
        }

        return false;
    });
};

$(() => {
    $cache.body.on('gtm:hook', (e, data) => {
        e.preventDefault();

        const { targetGtmEl, context, productId } = data;

        const url = window.gtmHookCallUrl;

        if (!isEmpty(url)) {
            $.ajax({
                url,
                method: 'POST',
                data: { context, productId },
                success: function (response) {
                    const { success, gtmEventHookPayload, event } = response;
                    if (success) {
                        targetGtmEl.attr('data-tracking-click-event', event);
                        targetGtmEl.attr('data-tracking-event-payload', JSON.stringify(gtmEventHookPayload));
                    }
                },
            });
        }
    });

    $cache.body.on('gtm:add:event', (e, response) => {
        const datalayer = get(response, 'datalayer', []);
        if (!isEmptyDatalayer(datalayer)) {
            window.dataLayer = [...window.dataLayer, ...datalayer];
        }
    });

    $cache.body.on('click', '.plp-display-mode-btn', function () {
        const $this = $(this);
        const url = $this.closest('.switch-view-container').attr('data-url');
        const displayMode = $this.attr('data-plp-display-mode');

        if (url && displayMode) {
            $.ajax({
                url: url,
                type: 'post',
                data: { displayMode },
                success: function (data) {
                    if (data.success) {
                        $('.product-grid')
                            .find('.product-tile')
                            .each(function () {
                                const $tile = $(this);
                                const payload = $tile.attr('data-tracking-event-payload');
                                let parsedPayload = {};
                                try {
                                    parsedPayload = JSON.parse(payload);
                                } catch (error) {
                                    parsedPayload = {};
                                }

                                const updatedSearchEvent = parsedPayload.map((datalayerEvent) => {
                                    if (datalayerEvent.event === 'search_click_result') {
                                        return { ...datalayerEvent, displayMode };
                                    }
                                    return { ...datalayerEvent };
                                });
                                $tile.attr('data-tracking-event-payload', JSON.stringify(updatedSearchEvent));
                            });
                    }
                },
            });
        }
    });

    $cache.body.on('gtm:trigger:event', (e, details) => {
        e.preventDefault();

        const url = window.gtmTriggerEventUrl;

        if (!isEmpty(url)) {
            $.ajax({
                url,
                method: 'POST',
                data: {
                    eventDetails: JSON.stringify(details),
                },
                success: function (response) {
                    $cache.body.trigger('gtm:add:event', response);
                },
            });
        }
    });

    $cache.body.on('click', 'button[value="submit-shipping"]', function () {
        $cache.body.trigger('gtm:trigger:event', {
            eventId: $(this).attr('data-event'),
        });
    });
});

/**
 * @typedef {import('jquery')} jQuery
 */

/**
 * Detects all current and future Slick Carousel instances on the page
 * as they are initialized. It fires a callback for each detected slider.
 * This function uses a MutationObserver to efficiently detect dynamically added sliders.
 *
 * @param {function(jQuery): void} callback - A function to be executed for each
 * detected slick slider. The slider's jQuery element is passed as the first argument.
 */
const onSlickInit = (callback) => {
    const SLICK_CLASS = '.slick-initialized';

    const existingSliders = $(SLICK_CLASS);
    if (existingSliders.length > 0) {
        existingSliders.each(function () {
            callback($(this));
        });
    }

    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const el = node;
                        // Check if the added node is a slider itself
                        if (el.matches(SLICK_CLASS)) {
                            callback($(el));
                        }
                        // Check if the added node contains new sliders
                        $(el)
                            .find(SLICK_CLASS)
                            .each(function () {
                                callback($(this));
                            });
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

/**
 * This function will insert gtm events generated by hook to slider controls
 *
 * @param {jQuery} $slider - The jQuery object for the detected slider.
 */
const handleNewSlider = ($slider) => {
    let isUpdated = false;
    const sliderClickEvent = $slider.attr('data-tracking-click-event');
    const sliderClickPayload = $slider.attr('data-tracking-event-payload');
    const sliderClickLevel = $slider.attr('data-tracking-event-level');

    if (!isEmpty(sliderClickEvent) && !isEmpty(sliderClickPayload)) {
        $slider.find('.slick-arrow').each((_, arrow) => {
            $(arrow).attr('data-tracking-click-event', sliderClickEvent);
            $(arrow).attr('data-tracking-event-payload', sliderClickPayload);
            $(arrow).attr('data-tracking-event-level', sliderClickLevel);
            isUpdated = true;
        });
        if (isUpdated) {
            $slider.removeAttr('data-tracking-click-event');
            $slider.removeAttr('data-tracking-event-payload');
            $slider.removeAttr('data-tracking-event-level');
        }
    }
};

onSlickInit(handleNewSlider);
